import DetailStat from "./DetailStat";

export default DetailStat;
